import React from "react";
import {
    ATTR_OBJ_TYPE,
    hasFileExtension,
    OBJ_TYPE_ITM,
    OBJ_TYPE_ITM_OBS, OBJ_TYPE_ITM_PICT_LOC, OBJ_TYPE_LST_PROJ_PICT
} from "../prodect/ProsConnect";
import * as prosConnect from "../prodect/ProsConnect";
import prosAppNotif, {prosAppNotifConfirm} from "../prodect/ProsAppNotif"
import {ConfirmButton, CancelButton} from "./BasicButton"
import {MAX_UPLOAD_FILE_SIZE} from "../config";

export default class FileUploader extends React.Component {

    _init_state = {
        files: null,
        uploading: false,
        dragging: false,
        confirmed: (this.props.confirmUpload ? false : true),
        errors: [],
        progressPerFile: 0
    }

    constructor(props) {
        super(props)
        this.state = this._init_state
    }

    checkToWarnCloseToCapacityLimit() {
        if (!prosConnect.getActiveProject()) {
            return
        }
        let stats = prosConnect.getActiveProject().getItemCountStats()
        if(stats) {
            let remainingCapacity = stats.itemsCountLimit - stats.itemsTotal
            if (remainingCapacity < 10) {
                prosAppNotif('HUOM projektissa tilaa ' + remainingCapacity + ' tiedolle')
            }
        }
    }

    resetFileUploader(){
        if(typeof this.props.callback === 'function') this.props.callback(this.state.files)
        this.setState(this._init_state)
    }

    isSupportedFile(file) {
        const lowerCaseName = file.name.toLowerCase()
        for (let i = 0; i < this.props.formats.length; i++) {
            if (hasFileExtension(lowerCaseName, this.props.formats[i]) > 0) return true
            if (file.type) {
                const lowerCaseType = file.type.toLowerCase()
                if(this.isImageFile(lowerCaseName)){
                    if (lowerCaseType === 'image/' + this.props.formats[i]) return true
                    if(this.props.formats[i] === 'jpg' || this.props.formats[i] === 'jpeg'){
                        if (lowerCaseType === 'image/jpeg') return true
                    }
                }
            }
        }
        return false
    }

    isImageFile(filename){
        const fileExt = filename.split('.').pop()
        if(fileExt && prosConnect.IMPORT_IMG_FILE_TYPES.includes('.' + fileExt.toLowerCase())){
            return true
        }
        //prosLogErr('Not a picture image file', filename)
        return false
    }

    isVideoFile(filename){
        const fileExt = filename.split('.').pop()
        if(fileExt && prosConnect.IMPORT_VIDEO_FILE_TYPES.includes('.' + fileExt.toLowerCase())){
            return true
        }
        //prosLogErr('Not a video file', filename)
        return false
    }

    showSupportedFormats(alert){
        const txt = 'Tiedosto pitää olla ' + this.props.formats.join(', ') + ' muodossa.'
        if(alert) window.alert(txt)
        else prosAppNotif(txt)
    }

    isTooManyFiles(amount){
        if(this.props.fileslimit && amount > this.props.fileslimit){
            alert('Liian monta tiedostoa. Vain ' + this.props.fileslimit + ' tiedostoa kerralla.')
            return true
        }
        return false
    }

    loadProgress =(obj)=> {
        const percent = Math.round(obj.progress/obj.total * 100)
        this.setState({
            progressPerFile: percent + '%'
        })
    }

    confirmUpload(){
        if(!this.state.confirmed && this.props.confirmUpload && this.state.loading) return
        this.startFileUpload()
    }

    async startFileUpload() {
        let fatalError = this.isTooManyFiles(this.state.files.length)
        let successes = 0
        if(fatalError){
            this.resetFileUploader()
            return
        }
        let errors = []
        const files = this.state.files
        for (let i = 0; i < files.length; i++) {
            let file = files[i]
            const remainingFiles = this.state.files.filter(item => item !== file)
            if (file.size && file.size > MAX_UPLOAD_FILE_SIZE) {
                errors.push({name: file.name, text: "Liian suuri tiedosto"})
                prosAppNotif('Liian suuri tiedosto - maksimi raja asetettu '
                    + Math.floor(MAX_UPLOAD_FILE_SIZE/1000000) + ' MB')
            }else if (!this.isSupportedFile(file)) {
                errors.push({name: file.name, text: "Väärä tiedostomuoto"})
                this.showSupportedFormats(false)
            } else {
                if((this.isImageFile(file.name) || this.isVideoFile(file.name)) && this.props.item){
                    let fileNameInAws = await prosConnect.startFileUpload({file: file, cb: (o)=> this.loadProgress(o)})
                    if (this.props.hasOwnProperty('fileNameCb') && typeof this.props.fileNameCb === "function") {
                        this.props.fileNameCb(fileNameInAws)
                    } else if (this.props.item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS
                        || this.props.item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM
                        || this.props.item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_PICT_LOC
                        || this.props.item[ATTR_OBJ_TYPE] === OBJ_TYPE_LST_PROJ_PICT){
                        await prosConnect.getActiveProject().createPictureItem(fileNameInAws, this.props.item)
                    }
                }
                successes++
            }
            this.checkToWarnCloseToCapacityLimit()

            this.setState({
                files: remainingFiles.length < 1 ? null : remainingFiles,
                uploading: remainingFiles.length < 1 ? false : true,
                progressPerFile: 0
            })

            if(remainingFiles.length < 1 && errors.length > 0) {
                this.setState({
                    files: null,
                    errors: errors,
                    uploading: true,
                    progressPerFile: 0
                }, ()=>{
                    prosAppNotifConfirm('Valmis, mutta virheita tapahtui (' + errors.length + ')')
                })
            }

            if(remainingFiles.length < 1 && !fatalError){
                this.resetFileUploader()
                if(typeof this.props.callback === 'function' && successes > 0) this.props.callback(files)
            }
        }
    }

    handleFileSelect = evt => {
        this.setState({
            files: Array.from(evt.target.files),
            loading: true,
        }, ()=> this.confirmUpload())
    }

    handleDragOver = evt => {
        //Prevent file from being opened in browser)
        evt.preventDefault()
        this.setState({
            dragging: true
        })
    }

    handleDragLeave = evt =>{
        evt.preventDefault()
        this.setState({
            dragging: false
        })
    }

    handleFileDrop = evt => {
        evt.preventDefault()
        let files = []
        if (evt.dataTransfer.items) {
            for (let i = 0; i < evt.dataTransfer.items.length; i++) {
                // If dropped items aren't files, reject them
                if (evt.dataTransfer.items[i].kind === 'file') {
                    files.push(evt.dataTransfer.items[i].getAsFile())
                }
            }
        }else{
            //ESD: NOT TESTED THIS
            //Use DataTransfer interface to access the file(s)
            for (let i = 0; i < evt.dataTransfer.files.length; i++) {
                files.push(evt.dataTransfer.files[i].name)
            }
        }
        this.setState({
            files: files,
            loading: true,
            dragging: false,
        }, ()=> this.confirmUpload())
    }

    renderFileUploadForm() {
        return <>
            <form>
                <label htmlFor="selectFile"
                   className={"btn btn-icon btn-icon-left btn-icon-download btn-2nd width-100"}
                ><span>Valitse tiedosto{this.props.fileslimit !== 1 ? 't' : null}</span></label>
                <input
                    id="selectFile"
                    type="file"
                    multiple={this.props.fileslimit !== 1}
                    onChange={this.handleFileSelect}
                    className="dom-hide"
                />
            </form>
        </>
    }

    groupFileTypes(filearr){
        const imgs = filearr.filter(f => this.isImageFile(f))
        const vids = filearr.filter(f => this.isVideoFile(f))
        const others = filearr.filter(f => !this.isImageFile(f) && !this.isVideoFile(f))
        return {
            images: imgs,
            videos: vids,
            files: others
        }
    }

    localizeText(text, plural){
        const en = {
            images: 'Kuva',
            videos: 'Video',
            files: 'Tiedosto'
        }
        return en[text] + (plural ? 't' : '')
    }

    renderFileType(title, extensions){
        if(extensions.length < 1){
            return null
        }
        return <div
                key={"fu__" + title}
            >
                <strong className={"text-sm"}>{this.localizeText(title, extensions.length > 1)}</strong>
                <div className={"element-set-sm"}>
                    {extensions.map(ext => <span key={"fu__2" + ext} className={"text-tag"}>{ext.substring(1)}</span>)}
                </div>
            </div>
            }

    renderFileTypes(){
        const fileTypeObj = this.groupFileTypes(this.props.formats)
        return Object.keys(fileTypeObj).map(k => this.renderFileType(k, fileTypeObj[k]))
    }

    renderDropzoneContent(){
        return <>
            <figure>
                <img src={"/images/illustrations/cloud-upload.svg"} alt={"Pudota tiedostot tähän"}/>
            </figure>
            <p>Pudota tiedostot tähän</p>
            <footer className={"element-set flex-gap-lg"}>
                {this.renderFileTypes()}
            </footer>
        </>
    }

    render() {
        if (this.props.confirmUpload && !this.state.confirmed && this.state.loading && this.state.files) {
            let outputList = this.state.files.map((file, i) => {
                return <li key={file.name + '__' + i}>{file.name}</li>
            })
            return <>
                <div
                    className={"fileupload-dropzone waiting"}
                >
                    <h3>Vahvista lataus</h3>
                    <p>Oletko varma, että haluat ladata seuraavat tiedostot palvelimelle?</p>
                    <ul className={"list-no-style"}>
                        {outputList}
                    </ul>
                </div>
                <div className={"btn-set_center"}>
                    <CancelButton
                        action={()=> this.resetFileUploader()}
                    />
                    <ConfirmButton
                        label={"Jatka"}
                        action={()=> {
                            this.setState({confirmed: true})
                            this.startFileUpload()
                        }}
                    />
                </div>
            </>
        }
        let content = null
        if(this.state.loading){
            if(this.state.files){
                content = this.state.files.map((file, i) => {
                    const progressElem = i === 0 ?
                        <div className={"progressbar-indicator"} style={{width: this.state.progressPerFile}}></div>
                        : null
                    return <div key={"ulfile" + i} className={"margin-bottom"}>
                        <p className={"margin-0"}>{file.name}</p>
                        <div className={"progressbar"}>{progressElem}</div>
                    </div>
                })
            }else{
                content = this.state.errors.map((error) => {
                    return <p>{error.name}: {error.text}</p>
                })
            }
            return <div className={"msg msg-info"}>
                {this.state.files ? <h3>Tiedostoja jäljellä: {this.state.files.length}</h3> : null}
                {content}
            </div>
        }

        return <div className={"fileupload"}>
            <div
                onDrop={this.handleFileDrop}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragLeave}
                className={"fileupload-dropzone" + (this.state.dragging ? " active" : "")}
            >{this.renderDropzoneContent()}
            </div>
            {this.renderFileUploadForm()}
        </div>
    }
}